import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface SucheErrorEvent {
  text: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private readonly errorEventSubject$: Subject<SucheErrorEvent> = new Subject<SucheErrorEvent>();
  public errorEvent$: Observable<SucheErrorEvent> = this.errorEventSubject$.asObservable();

  public setErrorEvent(error: SucheErrorEvent): void {
    this.errorEventSubject$.next(error);
  }
}
